import React, { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import { usePermissions } from 'react-admin';

import { TextField, StatusField } from '~/components';
import { PersonCircleIcon as IndividualsIcon } from '~/img';
import { AsideBase } from '~/layout';
import { useApiIdentitiesT } from '../utils';
import { useIndividualById } from '~/hooks/individuals';
import { buildName } from '~/utils';
import { KycLevelField } from '~/components/ra';
import GoToProfile from './GoToProfile';
import ReferenceField from '~/components/ReferenceField';
import UnlinkProfileAction from '~/components/ApiIdentity/UnlinkProfileAction';

interface Props {
  profileId?: string;
  identityId?: string;
  identityProfileId?: string;
  loading?: boolean;
}

const LinkedIndividualAside: FC<Props> = (props) => {
  const { profileId, identityId, identityProfileId, loading } = props;

  const individualQuery = useIndividualById(profileId);
  const { permissions } = usePermissions();
  const hasUnlinkPermission = permissions?.includes('apiIdentity.unlinkProfile');
  const classes = useStyles();
  const t = useApiIdentitiesT();

  const resultLoading = loading || individualQuery.isLoading;

  return (
    <AsideBase>
      <Grid container spacing={2}>
        <Grid container item spacing={1} className={classes.layout}>
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <TextField
                label={t('INDIVIDUAL')}
                icon={
                  <SvgIcon>
                    <IndividualsIcon />
                  </SvgIcon>
                }
                loading={resultLoading}
                ellipsis
                noPaddingLeft
              >
                {buildName('individuals', individualQuery.data)}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField label={t('status')} loading={resultLoading} ellipsi>
                <StatusField status={individualQuery.data?.status} />
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField label={t('kycLevel')} loading={resultLoading} ellipsis>
                {individualQuery.data?.kycLevel && (
                  <KycLevelField
                    record={individualQuery.data as any}
                    source='kycLevel'
                    type='text'
                    addLabel={false}
                  />
                )}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              {resultLoading ? null : (
                <ReferenceField
                  record={{ id: individualQuery.data?.solutionId!, type: 'SOLUTION' }}
                  withLink={false}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container item justify='flex-end'>
          {hasUnlinkPermission && (
            <Grid item>
              <UnlinkProfileAction identityId={identityId} profileId={identityProfileId} />
            </Grid>
          )}
          {profileId && (
            <Grid item>
              <GoToProfile profileType='INDIVIDUAL' profileId={profileId} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </AsideBase>
  );
};

const useStyles = makeStyles((theme) => ({
  layout: {
    marginLeft: theme.spacing(3),
  },
  active: {
    color: theme.palette.success.main,
    fontWeight: 500,
  },
}));

export default LinkedIndividualAside;
